import { useContext } from 'react';
import { Routes, Route, ScrollRestoration } from 'react-router-dom';

import Snackbar from '@frolight/components/Snackbar';

import SnackbarContext from '@frolight/context/SnackbarProvider';

import PersistLogin from '@frolight/components/PersistLogin';
import RequireAuth from '@frolight/components/RequireAuth';
import RequireGuest from '@frolight/components/RequireGuest';
import AccountCreationCompletion from '@frolight/views/AccountCreationCompletion';
import Dashboard from '@frolight/views/Dashboard';
import DeviceRegistration from '@frolight/views/DeviceRegistration';
import GatewayDetail from '@frolight/views/GatewayDetail';
import SignIn from '@frolight/views/SignIn'
import UserPreferences from '@frolight/views/user/UserPreferences';
import CookiePolicy from '@frolight/views/legal/CookiePolicy';
import PrivacyPolicy from '@frolight/views/legal/PrivacyPolicy';
import TermsOfUse from '@frolight/views/legal/TermsOfUse';
import NotFoundPage from '@frolight/views/NotFoundPage';

const ROLES = {
  ADMINISTRATOR: 'administrator',
  ORGANISATION_ADMINISTRATOR: 'organisation_administrator',
  ORGANISATION_USER: 'organisation_user'
};

const App = () => {
  const {
    isShown: snackbarIsShown
  } = useContext(SnackbarContext);

  return (
    <>
      <ScrollRestoration />
      <Routes>
        <Route element={ <PersistLogin /> }>
          {/* Routes for all */}
          <Route
            exact="true"
            path="/register-device/:registrationCode"
            element={ <DeviceRegistration /> }
          />
          <Route
            exact="true"
            path="/confirm-email/:verificationToken"
            element={ <AccountCreationCompletion /> }
          />
          <Route
            exact="true"
            path="/legal/terms-of-use"
            element={ <TermsOfUse /> }
          />
          <Route
            exact="true"
            path="/legal/cookie-policy"
            element={ <CookiePolicy /> }
          />
          <Route
            exact="true"
            path="/legal/privacy-policy"
            element={ <PrivacyPolicy /> }
          />
          {/* Protected routes */}
          <Route element={ <RequireAuth allowedRoles={ [ROLES.ADMINISTRATOR, ROLES.ORGANISATION_ADMINISTRATOR, ROLES.ORGANISATION_USER ] } /> }>
            <Route
              exact="true"
              path="/"
              element={ <Dashboard /> }
            />
            <Route
              exact="true"
              path="/gateways/:gatewayId"
              element={ <GatewayDetail /> }
            />
            <Route
              exact="true"
              path="/preferences"
              element={ <UserPreferences /> }
            />
          </Route> 
          {/* Guest-only routes */}
          <Route element={ <RequireGuest /> }>
            <Route
              exact="true"
              path="/sign-in"
              element={ <SignIn /> }
            />
          </Route>
          {/* 404 */}
          <Route
            path="*"
            element={ <NotFoundPage /> }
          />
        </Route>
      </Routes>
      {
        snackbarIsShown && <Snackbar />
      }
    </>
  );
};

export default App;
